import axios from 'axios';

export interface NewsArticle {
  id: string;
  title: string;
  source: string;
  url: string;
  publishedAt: string;
  summary: string;
  relevance: string;
}

class NewsService {
  private static instance: NewsService;

  static getInstance(): NewsService {
    if (!NewsService.instance) {
      NewsService.instance = new NewsService();
    }
    return NewsService.instance;
  }

  async getDisasterNews(): Promise<NewsArticle[]> {
    try {
      // Using GDELT Project - free, no key needed
      const response = await axios.get('https://api.gdeltproject.org/api/v2/summary/summary', {
        params: {
          k: 'flood OR fire OR earthquake OR cyclone OR disaster',
          d: 'web',
          t: '24h',
          format: 'json'
        }
      });

      // Parse GDELT response
      if (response.data && response.data.articles) {
        return response.data.articles.slice(0, 20).map((article: any, index: number) => ({
          id: `news-${index}-${Date.now()}`,
          title: article.title || 'Disaster News',
          source: article.source || 'Unknown',
          url: article.url || '#',
          publishedAt: article.seendate || new Date().toISOString(),
          summary: article.excerpt || article.title || 'News article about disaster',
          relevance: article.theme?.includes('disaster') ? 'high' : 'medium'
        }));
      }
      return this.getMockNews();
    } catch (error) {
      console.error('Error fetching news:', error);
      return this.getMockNews();
    }
  }

  private getMockNews(): NewsArticle[] {
    return [
      {
        id: '1',
        title: 'Severe Flooding in Coastal Region',
        source: 'BBC News',
        url: '#',
        publishedAt: new Date().toISOString(),
        summary: 'Heavy rains cause flooding in coastal areas, evacuations underway.',
        relevance: 'high'
      },
      {
        id: '2',
        title: 'Earthquake Aftershocks Continue',
        source: 'CNN',
        url: '#',
        publishedAt: new Date(Date.now() - 3600000).toISOString(),
        summary: 'Multiple aftershocks felt after magnitude 6.2 earthquake.',
        relevance: 'high'
      }
    ];
  }
}

export default NewsService.getInstance();